/*
  Product variant engine (Stage 2 of the OS 2.0 migration, Jul 2026).
  Replaces Shopify option_selection.js, timber.productPage and both legacy
  selectCallback definitions with one vanilla module.

  Contract:
  - Reads config from #ProductVariantsJson (JSON: { moneyFormat, product }),
    emitted by snippets/product-variant.liquid.
  - Binds to .single-option-selector[data-option-index] selects (Liquid-rendered).
  - Updates: #ProductPrice, #ComparePrice (+ its wrapper visibility), #AddToCart,
    #AddToCartText (strings kept from timber: Add to cart / Soldout / Unavailable),
    .quantity-selector visibility, #ProductSku, .variant-sku, hidden #productSelect,
    .affirm-as-low-as data-amount + affirm.ui.refresh (the fix for the old dead code),
    gallery via window.pgGalleryGoToImage, URL ?variant= via history.replaceState.
  - Dispatches document CustomEvent 'variant:change' with { variant } for future consumers.
*/
(function () {
  'use strict';

  function init() {
    var dataEl = document.getElementById('ProductVariantsJson');
    if (!dataEl) return;

    var cfg;
    try { cfg = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var product = cfg && cfg.product;
    if (!product || !product.variants) return;
    var moneyFormat = cfg.moneyFormat || '$@amount@'.replace('@amount@', '{' + '{amount}' + '}');

    var selects = Array.prototype.slice.call(
      document.querySelectorAll('.single-option-selector[data-option-index]')
    );
    if (!selects.length) return; /* single default variant: nothing to bind */

    var master     = document.getElementById('productSelect');
    var priceEl    = document.getElementById('ProductPrice');
    var compareEl  = document.getElementById('ComparePrice');
    var compareWrap = compareEl ? compareEl.parentElement : null;
    var btn        = document.getElementById('AddToCart');
    var btnText    = document.getElementById('AddToCartText');
    var qtyEl      = document.querySelector('.quantity-selector');
    var skuMain    = document.getElementById('ProductSku');

    function thousands(intStr) {
      return intStr.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function formatMoney(cents) {
      var parts = (cents / 100).toFixed(2).split('.');
      var amount = thousands(parts[0]) + '.' + parts[1];
      var noDec = thousands(String(Math.round(cents / 100)));
      var comma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
      return moneyFormat
        .replace(/\{\{\s*amount\s*\}\}/g, amount)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDec)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, comma);
    }

    function currentVariant() {
      var opts = selects.map(function (s) { return s.value; });
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        var match = true;
        for (var j = 0; j < opts.length; j++) {
          if (v.options[j] !== opts[j]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function setSku(text) {
      if (skuMain) skuMain.textContent = text;
      var extra = document.querySelectorAll('.variant-sku');
      for (var i = 0; i < extra.length; i++) extra[i].textContent = text;
    }

    function apply(variant) {
      if (variant) {
        if (priceEl) priceEl.textContent = formatMoney(variant.price);

        if (compareEl && compareWrap) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            compareEl.textContent = formatMoney(variant.compare_at_price);
            compareWrap.style.display = '';
          } else {
            compareWrap.style.display = 'none';
          }
        }

        if (variant.available) {
          if (btn) { btn.disabled = false; btn.classList.remove('disabled'); }
          if (btnText) btnText.textContent = 'Add to cart';
          if (qtyEl) qtyEl.style.display = '';
        } else {
          if (btn) { btn.disabled = true; btn.classList.add('disabled'); }
          if (btnText) btnText.textContent = 'Soldout';
          if (qtyEl) qtyEl.style.display = 'none';
        }

        setSku(variant.sku || '');

        if (master) {
          var opt = master.querySelector('option[value="' + variant.id + '"]');
          if (opt) master.value = String(variant.id);
        }

        /* Affirm monthly estimate: price in cents, then refresh the promo */
        var affirmEls = document.querySelectorAll('.affirm-as-low-as');
        for (var i = 0; i < affirmEls.length; i++) {
          affirmEls[i].setAttribute('data-amount', variant.price);
        }
        if (window.affirm && window.affirm.ui && typeof window.affirm.ui.refresh === 'function') {
          try { window.affirm.ui.refresh(); } catch (e) {}
        }

        if (variant.featured_image && typeof window.pgGalleryGoToImage === 'function') {
          window.pgGalleryGoToImage(variant.featured_image.id, variant.featured_image.src);
        }

        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) {}
      } else {
        if (btn) { btn.disabled = true; btn.classList.add('disabled'); }
        if (btnText) btnText.textContent = 'Unavailable';
        if (qtyEl) qtyEl.style.display = 'none';
        setSku('');
      }

      try {
        document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: variant } }));
      } catch (e) {}
    }

    for (var i = 0; i < selects.length; i++) {
      selects[i].addEventListener('change', function () { apply(currentVariant()); });
    }

    /* Initial sync, idempotent against the server-rendered state.
       Also puts ?variant= into the URL, same as enableHistoryState did. */
    apply(currentVariant());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
